// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STARS_RATING_SCORE_A11Y_score = "Hodnocen\u00ed %(score)s z 5 hv\u011bzdi\u010dek";
export const STARS_RATING_SCORE_score = "%(score)s z 5";
